<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Proveedores</h4>
            <div class="small text-muted">Adminsitración de todos los proveedores que interactuan con el software</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col sm="6" md="6" lg="4">
              <Widget :configWidget="configWidget" reference="indicator_total_suppliers" :hasAccess="configWidget.elements.indicatorTotalSuppliers" />                            
            </b-col>
            <b-col sm="6" md="6" lg="4">
              <Widget :configWidget="configWidget" reference="list_suppliers_without_access" :hasAccess="configWidget.elements.listSuppliersWithoutAccess" />                            
            </b-col>
          </b-row>
        </b-col>  
        <b-col lg="3">
          <b-list-group class="mb-1" v-if="configSubView.elements.crud">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openSuppliers()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Proveedores</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Adminsitración del proveedor
              </p>
            </b-list-group-item>
          </b-list-group>    
          
          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PROVEEDORES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.PROVEEDORES,
          profile_id: Profiles.PERSONAL,
          elements: {             
            indicatorTotalSuppliers: true, 
            listSuppliersWithoutAccess: true,           
          }
        },
        configSubView: {
          module_id: Modules.PROVEEDORES,
          profile_id: Profiles.PERSONAL,
          elements: {
            crud: true,
            php_custom: true,
          }
        },         
        primaryColor: '',
        arr: {
          PHPCustom: []
        }        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */      
      this.configWidget.elements.indicatorTotalSuppliers = Helper.hasAccessWidget(this.configWidget, 'indicator_total_suppliers')      
      this.configWidget.elements.listSuppliersWithoutAccess = Helper.hasAccessWidget(this.configWidget, 'list_suppliers_without_access')      
      /* Fin configuracion */

      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.crud = Helper.showAccessView(this.configSubView, 'crud')      
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */        
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      openSuppliers() {
        this.$router.push({ name: 'SuppliersListStaff' })
      }, 
      
      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.PROVEEDORES)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }      
    }    
   
  }
</script>

<style>

</style>
